var React = require('react');

function KeypadHome (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.578 13.414v-4.76h4.844v4.76h2.422V6.996L8 2.236l-4.844 4.76v6.418h2.422zM8 0l8 7.86h-1.542V15h-5.65v-4.76H7.192V15H1.542V7.86H0L8 0z","fill":"currentColor"}));
}

KeypadHome.defaultProps = {"width":"16","height":"15","viewBox":"0 0 16 15"};

module.exports = KeypadHome;

KeypadHome.default = KeypadHome;
